<template>
	<div>
		<AyudaVisual v-if="ayuda" v-on:close="closeHelp" texto="Elije de esta lista los partidos que quieres en tu quiniela y haz click en hacer quiniela" :comp="$refs.partidosDisponibles" id="jugar" :cookie="false" :scrollDownOnShow="false" />
		<Panel :title="title" ref="partidosDisponibles" :help="true" v-on:helpClicked="helpClick">
			<div class="partidos-disponibles">

				<p class="panel-block" style="border: 0;" v-show="partidos_disponibles.length == 0">No hay partidos disponibles en este momento..</p>
				<form action="" v-if="partidos_disponibles.length > 0" @submit.prevent="hacerQuiniela">
					<transition-group name="card" mode="out-in">
						<div class="panel-block is-block" v-for="partido in sortedPartidos" :key="partido.id">
							<label :for="partido.id">
								<div class="columns is-mobile is-multiline is-gapless">
									<div class="column"><img :src="partido.torneo.logo_medium" :alt="partido.torneo.nombre"></div>
									<div class="column is-4-mobile is-5-tablet is-5-desktop">
										<p class="truncate">{{ partido.equipo_local.nombre }}</p>
										<p class="truncate">{{ partido.equipo_visitante.nombre }}</p>
									</div>
									<div class="column is-4">
										<div class="division">
											<p class="torneo truncate">{{ partido.torneo.nombre }}</p>
											<p class="truncate"><font-awesome-icon icon="calendar-alt"/> {{ $timeago.format(partido.inicia_tz,'es') }}</p>
										</div>
									</div>
									<div class="column is-narrow is-2-mobile is-1-tablet has-text-right">
										<input :id="partido.id" type="checkbox" :value="partido" v-model="partidos_selected">
									</div>
								</div>
							</label>
						</div>
					</transition-group>

						<div class="panel-block is-block panel-footer">
							<div class="level">
								<div class="level-left"></div>
								<div class="level-right">
									<div class="level-item">
										<button class="button is-info is-small" :disabled="partidos_selected.length < 2">
											<span class="icon">
												<font-awesome-icon icon="check-square"/>	
											</span>
											<span v-if="partidos_selected.length == 0 || partidos_selected.length > 1">Hacer quiniela</span>
											<span v-if="partidos_selected.length == 1">Elije minimo 2 partidos</span>
										</button>		
									</div>
								</div>
							</div>
						</div>
				</form>

			</div>
			
			<HacerQuinielaModal :partidos="partidos_selected" :active="modalQuiniela" v-on:close="closeModal"  />
		</Panel>
	</div>
</template>

<script>
	import Panel from '@/components/Panel'
	import { mapState } from 'vuex'
	import HacerQuinielaModal from '@/components/HacerQuinielaModal'
	import AyudaVisual from '@/components/AyudaVisual'
	
	export default {
		components: { Panel, HacerQuinielaModal, AyudaVisual },
		props: {
			title: {
				type: String,
				default: 'Elije tus partidos y haz tu quiniela!' 
			}
		},
		name: 'PartidosDisponibles',
		created(){
			this.$store.dispatch('partidos/fetchPartidosDisponibles')
		},
		data() {
			return {
				partidos_selected: [],
				modalQuiniela: false,
				ayuda: false
			};
		},
		methods: {
			hacerQuiniela(){
				this.modalQuiniela = true
			},
			closeModal(){
				this.modalQuiniela = false
			},
			helpClick(){
				this.ayuda = true
			},
			closeHelp(){
				this.ayuda = false
			}
		},
		computed: {
			sortedPartidos(){
				return this.partidos_disponibles.slice().sort((a,b) => a.inicia_tz > b.inicia_tz ? 1:-1)
			},
			...mapState('partidos',['partidos_disponibles'])
		}
	};
</script>

<style lang="css" scoped>
.partidos-disponibles{
	padding-bottom: 45px;
}
label{
	cursor: pointer;
}
div.panel-block:hover:not(:last-child){
	background-color: #d2cfcd;
}
.division{
	border-left: 1px dashed #b6a299;
	padding-left: 1em;
}
.partidos-diponibles{
	font-size: 1em;
}
form{
	font-size: 0.8em;
}
.torneo{
	font-weight: 200;
}
@media (min-width: 769px) { /* Desktop */
	.partidos-disponibles{
		max-height: 477px;
		overflow: scroll;
	}
}
</style>
